"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Generated API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.InternalJobsApi = exports.InternalJobsApiFactory = exports.InternalJobsApiFp = exports.InternalJobsApiAxiosParamCreator = void 0;
const axios_1 = require("axios");
// Some imports not used depending on template conditions
// @ts-ignore
const common_1 = require("../common");
// @ts-ignore
const base_1 = require("../base");
/**
 * InternalJobsApi - axios parameter creator
 * @export
 */
const InternalJobsApiAxiosParamCreator = function (configuration) {
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalJobsResourceGetInternalJobs: (...args_1) => __awaiter(this, [...args_1], void 0, function* (options = {}) {
            const localVarPath = `/internal-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'GET' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
        /**
         *
         * @param {TriggerRequest} [triggerRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalJobsResourceTriggerJob: (triggerRequest_1, ...args_2) => __awaiter(this, [triggerRequest_1, ...args_2], void 0, function* (triggerRequest, options = {}) {
            const localVarPath = `/internal-jobs`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, common_1.DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = Object.assign(Object.assign({ method: 'POST' }, baseOptions), options);
            const localVarHeaderParameter = {};
            const localVarQueryParameter = {};
            localVarHeaderParameter['Content-Type'] = 'application/json';
            (0, common_1.setSearchParams)(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = Object.assign(Object.assign(Object.assign({}, localVarHeaderParameter), headersFromBaseOptions), options.headers);
            localVarRequestOptions.data = (0, common_1.serializeDataIfNeeded)(triggerRequest, localVarRequestOptions, configuration);
            return {
                url: (0, common_1.toPathString)(localVarUrlObj),
                options: localVarRequestOptions,
            };
        }),
    };
};
exports.InternalJobsApiAxiosParamCreator = InternalJobsApiAxiosParamCreator;
/**
 * InternalJobsApi - functional programming interface
 * @export
 */
const InternalJobsApiFp = function (configuration) {
    const localVarAxiosParamCreator = (0, exports.InternalJobsApiAxiosParamCreator)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalJobsResourceGetInternalJobs(options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.internalJobsResourceGetInternalJobs(options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['InternalJobsApi.internalJobsResourceGetInternalJobs']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
        /**
         *
         * @param {TriggerRequest} [triggerRequest]
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalJobsResourceTriggerJob(triggerRequest, options) {
            return __awaiter(this, void 0, void 0, function* () {
                var _a, _b, _c;
                const localVarAxiosArgs = yield localVarAxiosParamCreator.internalJobsResourceTriggerJob(triggerRequest, options);
                const localVarOperationServerIndex = (_a = configuration === null || configuration === void 0 ? void 0 : configuration.serverIndex) !== null && _a !== void 0 ? _a : 0;
                const localVarOperationServerBasePath = (_c = (_b = base_1.operationServerMap['InternalJobsApi.internalJobsResourceTriggerJob']) === null || _b === void 0 ? void 0 : _b[localVarOperationServerIndex]) === null || _c === void 0 ? void 0 : _c.url;
                return (axios, basePath) => (0, common_1.createRequestFunction)(localVarAxiosArgs, axios_1.default, base_1.BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
            });
        },
    };
};
exports.InternalJobsApiFp = InternalJobsApiFp;
/**
 * InternalJobsApi - factory interface
 * @export
 */
const InternalJobsApiFactory = function (configuration, basePath, axios) {
    const localVarFp = (0, exports.InternalJobsApiFp)(configuration);
    return {
        /**
         *
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalJobsResourceGetInternalJobs(options) {
            return localVarFp.internalJobsResourceGetInternalJobs(options).then((request) => request(axios, basePath));
        },
        /**
         *
         * @param {InternalJobsApiInternalJobsResourceTriggerJobRequest} requestParameters Request parameters.
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        internalJobsResourceTriggerJob(requestParameters = {}, options) {
            return localVarFp.internalJobsResourceTriggerJob(requestParameters.triggerRequest, options).then((request) => request(axios, basePath));
        },
    };
};
exports.InternalJobsApiFactory = InternalJobsApiFactory;
/**
 * InternalJobsApi - object-oriented interface
 * @export
 * @class InternalJobsApi
 * @extends {BaseAPI}
 */
class InternalJobsApi extends base_1.BaseAPI {
    /**
     *
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalJobsApi
     */
    internalJobsResourceGetInternalJobs(options) {
        return (0, exports.InternalJobsApiFp)(this.configuration).internalJobsResourceGetInternalJobs(options).then((request) => request(this.axios, this.basePath));
    }
    /**
     *
     * @param {InternalJobsApiInternalJobsResourceTriggerJobRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof InternalJobsApi
     */
    internalJobsResourceTriggerJob(requestParameters = {}, options) {
        return (0, exports.InternalJobsApiFp)(this.configuration).internalJobsResourceTriggerJob(requestParameters.triggerRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
exports.InternalJobsApi = InternalJobsApi;
//# sourceMappingURL=internal-jobs-api.js.map